import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reportBuilderApi } from '../api/reportBuilderApi';
import type { ReportDefinitionRequest } from '../types/reportBuilder';

/**
 * POST /api/eraf/report-builder/reports — 리포트 정의 생성 (REPORT_CREATE)
 */
export function useCreateReportDef() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: ReportDefinitionRequest) => reportBuilderApi.create(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['report-builder', 'list'] });
    },
  });
}
